module.exports = __webpack_public_path__ + "img/poly-1.e537f073.png";